import { render, staticRenderFns } from "./VideoSettings.vue?vue&type=template&id=d1e6ebea&"
import script from "./VideoSettings.vue?vue&type=script&lang=ts&"
export * from "./VideoSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports